import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=16f227aa&scoped=true"
import script from "./Authentication.vue?vue&type=script&setup=true&lang=js"
export * from "./Authentication.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f227aa",
  null
  
)

export default component.exports